<template>
  <modal :name="name"
         :width="350"
         :height="280"
         @before-open="beforeOpen">
    <div class="content p-3" v-if="this.srcDay">
      <div class="row">
        <div class="col-md-12">
          <b>■コピー元</b><br/>
          {{this.srcDay.format('YYYY年MM月DD日')}}
        </div>
      </div>
      <div class="form-body p-t-30">
        <div class="form-actions actions">
          <div class="row">
            <div class="col-md-12 text-center">
              <input type="date" class="form-control" v-model="destDay">
            </div>
          </div>
          <div class="row p-t-10">
            <div class="col-md-12 text-center">
              <button type="button" class="action-button btn btn-rounded btn-success"
                      @click="copyDay"
                      :disabled="isProcessing">コピーする
              </button>
            </div>
          </div>
          <div class="row p-t-30">
            <div class="col-md-12 text-center">
              <a href="#" @click="close()">キャンセル</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'CopyDayModal',
  props: ['name'],
  components: {},
  data () {
    return {
      srcDay: null,
      destDay: null
    }
  },
  methods: {
    beforeOpen (event) {
      console.info(event)
      this.srcDay = event.params.targetDay
      this.destDay = this.srcDay.clone().add(1, 'days').format('YYYY-MM-DD')
    },
    close () {
      this.$modal.hide(this.name)
    },
    copyDay () {
      if (this.isProcessing) return
      if (!this.destDay) {
        alert('コピーする週を入力してください。')
        return
      }

      if (!confirm('コピーします。よろしいですか？')) {
        return
      }

      const destDay = dayjs(this.destDay, 'YYYY-MM-DD')
      this._copy(destDay)
    },
    _copy (destDay) {
      this.close()
      this.$emit('copy', destDay)
    }
  }
}
</script>

<style scoped>

</style>
